import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import { ProductService } from "../../../services/product.service";
import { ConfirmButtons } from "../../stateless/ConfirmButtons";
import Transition from "../../stateless/Transition";

const DeleteProduct = ({
  productId,
  onClose,
  open,
  productRemoved,
  detailProduct,
  detailProduct: {
    siteId,
    site: { name },
    inDistribution,
  },
}) => {
  console.log("productId", productId);
  console.log("detailProduct", detailProduct);

  const handleClose = () => onClose("delete");

  const handleDeleteProduct = async () => {
    if (inDistribution) {
      handleClose("delete");
      productRemoved(
        false,
        "El producto no se puede eliminar porque se encuentra en distribución",
        "removed"
      );
      return;
    }
    try {
      const { status } = await ProductService.deleteProduct(productId);
      if (status === 201)
        productRemoved(true, "Producto eliminado exitosamente", "removed");
    } catch (error) {
      console.log("error Delete product", error);
      productRemoved(
        false,
        "Error al eliminar el producto, volver a intentar",
        "removed"
      );
    }
    handleClose("delete");
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Eliminar producto
      </DialogTitle>
      <DialogContent>
        {siteId === 1 ? (
          <>¿Estas seguro de eliminar el producto del almacén?</>
        ) : (
          <>¿Estas seguro de eliminar el producto de la sucursal {name} ?</>
        )}

        <ConfirmButtons
          cancel={handleClose}
          acceptTitle="Confirmar"
          accept={handleDeleteProduct}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DeleteProduct;
